import { useEffect, useMemo, useState } from "react";
import { LAND, UNIS, copy } from "./data.js";

const majors = [["Electronics Engineering", "전자공학", 0]];
const matchData = [
  [
    "snu",
    0,
    "Match data is not available yet.",
    "아직 매칭 데이터가 없습니다.",
  ],
  [
    "pnu",
    0,
    "Match data is not available yet.",
    "아직 매칭 데이터가 없습니다.",
  ],
];
const timeline = [
  [
    "Now",
    "현재",
    "Korean / English test scores",
    "어학 성적 준비",
    "TOPIK 2 held. Book TOPIK 3 or IELTS 5.5.",
    "TOPIK 2급 보유. TOPIK 3급 또는 IELTS 5.5 응시 예약.",
    "",
  ],
  [
    "Oct",
    "10월",
    "Apostille of academic records",
    "학력 서류 아포스티유",
    "Diploma and transcripts certified by MFA Ukraine.",
    "우크라이나 외무부 인증 졸업증명·성적증명.",
    "Ukraine",
  ],
  [
    "Nov",
    "11월",
    "GKS scholarship application",
    "GKS 장학금 지원",
    "Global Korea Scholarship, embassy track.",
    "글로벌 코리아 장학금 대사관 트랙.",
    "Ukraine",
  ],
  [
    "Dec",
    "12월",
    "University applications",
    "대학 지원서 제출",
    "Seoul National University and Pusan National University applications.",
    "서울대학교와 부산대학교 지원.",
    "",
  ],
  [
    "Jan",
    "1월",
    "D-2 student visa documents",
    "D-2 학생비자 서류",
    "Admission certificate, financial proof and tuberculosis test.",
    "입학허가서, 재정 증명, 결핵 검사 확인서.",
    "Ukraine",
  ],
  [
    "Feb",
    "2월",
    "Housing and arrival",
    "주거 및 입국 준비",
    "Dormitory application and ARC appointment.",
    "기숙사 신청 및 외국인등록증 예약.",
    "",
  ],
];

const pnuPrograms = [
  {
    no: 41,
    departmentKo: "전자전기공학부 (전기공학전공)",
    departmentEn:
      "School of Electrical and Electronics Engineering (Electrical Engineering Major)",
    topik: "TOPIK 3 or above",
    url: "https://mse.pusan.ac.kr/mse/index.do",
  },
  {
    no: 42,
    departmentKo: "전자전기공학부 (전자공학전공)",
    departmentEn:
      "School of Electrical and Electronics Engineering (Electronics Engineering Major)",
    topik: "TOPIK 4 or above",
    url: "https://ee.pusan.ac.kr/ee/index.do",
  },
  {
    no: 43,
    departmentKo: "전자전기공학부 (반도체공학전공)",
    departmentEn:
      "School of Electrical and Electronics Engineering (Semiconductor Engineering Major)",
    topik: "TOPIK 4 or above",
    url: "https://eec.pusan.ac.kr/eehome/index.do",
  },
];

function Logo({ onClick }) {
  return (
    <button className="brand brand-button" onClick={onClick}>
      <b>Study</b>
    </button>
  );
}
function UniIcon() {
  return (
    <svg className="uni-icon" viewBox="0 0 12 12">
      <rect x="5" width="2" height="2" />
      <rect x="2" y="3" width="8" height="2" />
      <rect className="building" x="1" y="6" width="10" height="5" />
    </svg>
  );
}

export default function App() {
  const [lang, setLang] = useState("en");
  const [view, setView] = useState(
    location.hash === "#/pnu" ? "pnu" : "landing",
  );
  const [selected, setSelected] = useState("snu");
  const [hovered, setHovered] = useState(null);
  const [done, setDone] = useState({});
  const ko = lang === "ko",
    t = copy[lang],
    active = hovered || selected,
    selectedUni = UNIS.find((u) => u.id === selected);
  const cells = useMemo(
    () =>
      LAND.flatMap((row, r) =>
        [...row].map((v, c) => ({
          land: v === "1",
          uni: UNIS.some((u) => u.r === r && u.c === c),
          r,
          c,
        })),
      ),
    [],
  );
  useEffect(() => {
    const sync = () => setView(location.hash === "#/pnu" ? "pnu" : "landing");
    addEventListener("hashchange", sync);
    return () => removeEventListener("hashchange", sync);
  }, []);
  const navigate = (next) => {
    location.hash = next === "pnu" ? "/pnu" : "";
    setView(next);
  };
  return (
    <div className="app">
      <header>
        <div className="header-inner">
          <Logo onClick={() => navigate("landing")} />
          <div className="language">
            <button
              className={!ko ? "active" : ""}
              onClick={() => setLang("en")}
            >
              EN
            </button>
            <button
              className={ko ? "active" : ""}
              onClick={() => setLang("ko")}
            >
              KO
            </button>
          </div>
          <button
            className="auth"
            disabled
            title={ko ? "로그인 기능 준비 중" : "Login is coming soon"}
          >
            {t.login}
          </button>
        </div>
      </header>
      {view === "landing" ? (
        <main>
          <section className="hero wrap">
            <p className="kicker">{t.kicker}</p>
            <h1>{t.hero}</h1>
            <p className="lead">{t.heroBody}</p>
            <div className="chips origins">
              <button className="chosen">
                {ko ? "우크라이나" : "Ukraine"}
              </button>
            </div>
          </section>
          <section className="map-band">
            <div className="wrap">
              <div className="section-head">
                <div>
                  <p className="kicker">{ko ? "대학" : "Universities"}</p>
                  <h2>{t.mapTitle}</h2>
                  <p>{t.mapBody}</p>
                </div>
                <div className="coverage">
                  <span className="capital">
                    {ko ? "수도권" : "Capital area"}
                  </span>
                  <span className="regional">{ko ? "지방" : "Regional"}</span>
                </div>
              </div>
              <div className="map-content">
                <div className="map">
                  <div className="map-grid">
                    {cells.map((x, i) => (
                      <i
                        key={i}
                        className={`${x.land ? "land " : ""}${x.uni ? "uni " : ""}${UNIS.some((u) => u.id === active && u.r === x.r && u.c === x.c) ? "lit" : ""}`}
                      />
                    ))}
                  </div>
                  {UNIS.map((u, i) => (
                    <button
                      aria-label={ko ? u.ko : u.en}
                      key={u.id}
                      className={`marker ${selected === u.id ? "selected" : ""} ${hovered === u.id ? "hot" : ""}`}
                      style={{
                        left: `${((u.c + 0.5) / 24) * 100}%`,
                        top: `${((u.r + 0.5) / 28) * 100}%`,
                      }}
                      onClick={() => setSelected(u.id)}
                      onMouseEnter={() => setHovered(u.id)}
                      onMouseLeave={() => setHovered(null)}
                    >
                      <span className="tooltip">
                        <b>{ko ? u.ko : u.en}</b>
                        <small>{ko ? u.cityKo : u.cityEn}</small>
                      </span>
                    </button>
                  ))}
                </div>
                <div className="uni-panel">
                  <div className="uni-groups">
                    {["capital", "regional"].map((area) => (
                      <div className="uni-list-group" key={area}>
                        <h4>
                          {area === "capital"
                            ? ko
                              ? "수도권"
                              : "Capital area"
                            : ko
                              ? "지방"
                              : "Regional"}
                        </h4>
                        <div className="uni-list">
                          {UNIS.filter((u) => u.area === area).map((u, i) => (
                            <button
                              key={u.id}
                              className={active === u.id ? "active" : ""}
                              onClick={() => setSelected(u.id)}
                              onMouseEnter={() => setHovered(u.id)}
                              onMouseLeave={() => setHovered(null)}
                            >
                              <em>{i + 1}</em>
                              {ko ? u.ko : u.en}
                            </button>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="detail">
                    <h3>
                      {ko ? selectedUni.ko : selectedUni.en}
                      <small>
                        {ko ? selectedUni.cityKo : selectedUni.cityEn}
                      </small>
                    </h3>
                    {selectedUni.id === "pnu" && (
                      <button
                        className="pnu-detail-link"
                        onClick={() => navigate("pnu")}
                      >
                        {ko
                          ? "학과·입학 정보 전체 보기"
                          : "View departments & admissions"}{" "}
                        →
                      </button>
                    )}
                    {[
                      [
                        ko ? "지역 구분" : "Area",
                        selectedUni.area === "capital"
                          ? ko
                            ? "수도권"
                            : "Capital area"
                          : ko
                            ? "지방"
                            : "Regional",
                      ],
                      [
                        ko ? "영어 트랙" : "English track",
                        selectedUni.track
                          ? ko
                            ? "운영"
                            : "Available"
                          : ko
                            ? "한국어만"
                            : "Korean only",
                      ],
                      [
                        ko ? "한국어 요건" : "Korean requirement",
                        selectedUni.topik,
                      ],
                      [
                        ko ? "등록금" : "Tuition",
                        ko ? selectedUni.tuitionKo : selectedUni.tuitionEn,
                      ],
                      [
                        ko ? "생활비" : "Cost of living",
                        ko ? selectedUni.livingKo : selectedUni.livingEn,
                      ],
                    ].map(([a, b]) => (
                      <div className="fact" key={a}>
                        <span>{a}</span>
                        <b>{b}</b>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="content-section wrap">
            <h2>{t.popular}</h2>
            <div className="cards">
              {UNIS.map((u) => (
                <article
                  className={`uni-card ${u.id === "pnu" ? "clickable" : ""}`}
                  key={u.id}
                  onClick={u.id === "pnu" ? () => navigate("pnu") : undefined}
                >
                  <div>
                    <UniIcon />
                    <code className={`area-badge ${u.area}`}>
                      {u.area === "capital"
                        ? ko
                          ? "수도권"
                          : "CAPITAL AREA"
                        : ko
                          ? "지방"
                          : "REGIONAL"}
                    </code>
                  </div>
                  <h3>{ko ? u.ko : u.en}</h3>
                  <p>{ko ? u.cityKo : u.cityEn}</p>
                  {u.id === "pnu" && (
                    <button className="card-department">
                      {ko
                        ? "3개 학과 입학 정보 보기"
                        : "View 3 degree programs"}{" "}
                      →
                    </button>
                  )}
                  <div>
                    <span className={u.track ? "track" : ""}>
                      {u.track
                        ? ko
                          ? "영어 트랙"
                          : "English track"
                        : ko
                          ? "한국어 수업"
                          : "Korean only"}
                    </span>
                    <span>{u.topik}</span>
                  </div>
                </article>
              ))}
            </div>
          </section>
          <section className="content-section wrap">
            <h2>{t.major}</h2>
            <p>{t.majorBody}</p>
            <div className="chips majors">
              {majors.map((m) => (
                <button key={m[0]}>
                  {ko ? m[1] : m[0]} <small>{m[2]}</small>
                </button>
              ))}
            </div>
          </section>
          <section className="cta-wrap wrap">
            <div className="cta">
              <div>
                <h2>{t.cta}</h2>
                <p>{t.ctaBody}</p>
              </div>
              <button
                disabled
                title={ko ? "로그인 기능 준비 중" : "Login is coming soon"}
              >
                {ko ? "준비 중" : "Coming soon"}
              </button>
            </div>
          </section>
        </main>
      ) : view === "pnu" ? (
        <PnuPage ko={ko} onBack={() => navigate("landing")} />
      ) : (
        <Dashboard ko={ko} t={t} done={done} setDone={setDone} />
      )}
      <footer>
        {ko
          ? "초기 프로토타입 · 전 세계 유학생을 위한 정보 플랫폼"
          : "Early prototype · Information platform for international students"}
      </footer>
    </div>
  );
}

function PnuPage({ ko, onBack }) {
  return (
    <main className="pnu-page wrap">
      <button className="back-link" onClick={onBack}>
        ← {ko ? "대학 목록" : "All universities"}
      </button>
      <section className="pnu-hero">
        <div>
          <p className="kicker">
            {ko ? "부산 · 국립대학" : "BUSAN · NATIONAL UNIVERSITY"}
          </p>
          <h1>{ko ? "부산대학교" : "Pusan National University"}</h1>
          <p>
            {ko
              ? "GKS 대사관 트랙 B형 · 학사 과정"
              : "GKS Embassy Track Type B · Bachelor’s degree"}
          </p>
          <a
            className="alumni-link"
            href="https://pnualumni.pusan.ac.kr/eng/html/main/main.php"
            target="_blank"
            rel="noreferrer"
          >
            {ko ? "부산대학교 총동문회 영문 사이트" : "PNU Alumni Association"} ↗
          </a>
        </div>
        <div className="pnu-summary">
          <span>
            {ko ? "캠퍼스" : "Campus"}
            <b>Busan</b>
          </span>
          <span>
            {ko ? "입학 시기" : "Program starts"}
            <b>March / September</b>
          </span>
          <span>
            {ko ? "수업 언어" : "Instruction"}
            <b>Korean 100%</b>
          </span>
        </div>
      </section>
      <section className="programs-section">
        <div className="programs-heading">
          <div>
            <p className="kicker">{ko ? "모집 학과" : "DEGREE PROGRAMS"}</p>
            <h2>
              {ko
                ? "전자전기공학부 학사 과정"
                : "School of Electrical and Electronics Engineering"}
            </h2>
          </div>
          <span>3 {ko ? "개 전공" : "programs"}</span>
        </div>
        <div className="program-list">
          {pnuPrograms.map((p) => (
            <article className="program-card" key={p.no}>
              <div className="program-number">No. {p.no}</div>
              <div className="program-main">
                <h3>{ko ? p.departmentKo : p.departmentEn}</h3>
                {ko && <p>{p.departmentEn}</p>}
                <div className="program-facts">
                  <span>
                    <small>{ko ? "학과계열" : "Field of study"}</small>
                    <b>{ko ? "공학" : "Engineering"}</b>
                  </span>
                  <span>
                    <small>{ko ? "학위 과정" : "Degree program"}</small>
                    <b>{ko ? "학사" : "Bachelor’s degree"}</b>
                  </span>
                  <span>
                    <small>{ko ? "수학 기간" : "Period"}</small>
                    <b>4 {ko ? "년" : "years"}</b>
                  </span>
                  <span>
                    <small>
                      {ko
                        ? "어학당 이수 후 입학 요건"
                        : "Required TOPIK after language program"}
                    </small>
                    <b>{p.topik}</b>
                  </span>
                </div>
              </div>
              <a
                className="official-link"
                href={p.url}
                target="_blank"
                rel="noreferrer"
              >
                {ko ? "학과 웹사이트" : "Department website"} ↗
              </a>
            </article>
          ))}
        </div>
        <aside className="pnu-note">
          <b>{ko ? "안내" : "Note"}</b>
          <p>
            {ko
              ? "전화번호와 비고는 제공된 공시 자료에 기재되어 있지 않습니다. 상세 모집 요강은 각 학과 웹사이트에서 확인하세요."
              : "Telephone and remarks were not listed in the provided disclosure data. Check each department website for detailed admissions information."}
          </p>
        </aside>
      </section>
    </main>
  );
}

function Dashboard({ ko, t, done, setDone }) {
  const profile = ko
    ? [
        ["출신 국가", "우크라이나"],
        ["희망 전공", "전자공학"],
        ["학위 과정", "학부"],
        ["한국어 수준", "TOPIK 2급"],
        ["예산대", "학기당 250만원 이하"],
        ["선호 지역", "수도권 또는 충청"],
      ]
    : [
        ["Country", "Ukraine"],
        ["Preferred major", "Electronics Engineering"],
        ["Degree", "Bachelor's"],
        ["Korean level", "TOPIK 2"],
        ["Budget", "≤ ₩2.5M / semester"],
        ["Preferred region", "Capital area or Chungcheong"],
      ];
  return (
    <main className="dashboard wrap">
      <section className="profile-card">
        <div className="profile-top">
          <div>
            <p className="kicker">{t.profile}</p>
            <h1>Olena K.</h1>
          </div>
          <button>{ko ? "프로필 수정" : "Edit profile"}</button>
        </div>
        <div className="profile-grid">
          {profile.map((x) => (
            <div key={x[0]}>
              <small>{x[0]}</small>
              <b>{x[1]}</b>
            </div>
          ))}
        </div>
      </section>
      <section className="dash-section">
        <div className="dash-heading">
          <h2>{t.matches}</h2>
          <span>
            {ko
              ? "전공·한국어 수준·예산·지역 기준"
              : "Based on major, Korean level, budget and region"}
          </span>
        </div>
        <div className="cards">
          {matchData.map((m) => {
            const u = UNIS.find((x) => x.id === m[0]);
            return (
              <article className="match-card" key={m[0]}>
                <div>
                  <UniIcon />
                  <strong className={m[1] >= 85 ? "high" : ""}>{m[1]}%</strong>
                </div>
                <h3>{ko ? u.ko : u.en}</h3>
                <code>{ko ? u.cityKo : u.cityEn}</code>
                <p>{ko ? m[3] : m[2]}</p>
                <i>
                  <span
                    style={{ width: `${m[1]}%` }}
                    className={m[1] >= 85 ? "high" : ""}
                  />
                </i>
              </article>
            );
          })}
        </div>
      </section>
      <section className="dash-section">
        <h2>{t.timeline}</h2>
        <p>{t.timelineBody}</p>
        <div className="timeline">
          {timeline.map((row, i) => (
            <div className="timeline-row" key={row[0]}>
              <code>{ko ? row[1] : row[0]}</code>
              <button
                className={done[i] ? "done" : ""}
                onClick={() => setDone({ ...done, [i]: !done[i] })}
              >
                {done[i] ? "✓" : ""}
              </button>
              <div>
                <h3 className={done[i] ? "done-title" : ""}>
                  {ko ? row[3] : row[2]}{" "}
                  {row[6] && <small>{ko ? "우크라이나" : row[6]}</small>}
                </h3>
                <p>{ko ? row[5] : row[4]}</p>
              </div>
              <span className="doc">▤</span>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
